import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'

const Card = () => {
  const [allEvents, setAllEvents] = useState([])
  const [filteredVotives, setVotives] = useState([])
  const [selectedImage, setSelectedImage] = useState(null)
  const [loading, setLoading] = useState(true)
  const [selectedTypes, setSelectedTypes] = useState([])
  const [selectedMonth, setSelectedMonth] = useState(null)

  useEffect(() => {
    loadEvents()
  }, [])

  useEffect(() => {
    applyFilters()
  }, [selectedTypes, selectedMonth, allEvents])

  const loadEvents = async () => {
    try {
      const today = new Date()

      const { data, error } = await supabase
        .from('events')
        .select('*')
        .eq('status', 'published')
        .gte('date_end', today.toISOString())
        .order('date_start', { ascending: true })

      if (error) throw error

      setAllEvents(data || [])
    } catch (error) {
      console.error('Erreur lors du chargement des événements:', error)
      setAllEvents([])
    } finally {
      setLoading(false)
    }
  }

  const applyFilters = () => {
    const today = new Date()
    let filtered = allEvents.filter(item => new Date(item.date_end) > today)

    // Filtrer par types (AND - doit avoir tous les types sélectionnés)
    if (selectedTypes.length > 0) {
      filtered = filtered.filter(item =>
        Array.isArray(item.categories) &&
        selectedTypes.every(type => item.categories.includes(type))
      )
    }

    // Filtrer par mois (doit avoir le mois sélectionné)
    if (selectedMonth) {
      filtered = filtered.filter(item =>
        Array.isArray(item.categories) &&
        item.categories.includes(selectedMonth)
      )
    }

    setVotives(filtered)
  }

  const toggleType = (type) => {
    if (selectedTypes.includes(type)) {
      setSelectedTypes(selectedTypes.filter(t => t !== type))
    } else {
      setSelectedTypes([...selectedTypes, type])
    }
  }

  const selectMonth = (month) => {
    setSelectedMonth(selectedMonth === month ? null : month)
  }

  const resetFilters = () => {
    setSelectedTypes([])
    setSelectedMonth(null)
  }

  const handleClick = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const handleClose = () => {
    setSelectedImage(null);
  };


  if (loading) {
    return (
      <div className="w-full lg:max-w-[1250px] m-auto pb-6 px-4 flex justify-center items-center min-h-[400px]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-500"></div>
      </div>
    )
  }

  return (
    <div className='w-full  lg:max-w-[1250px] m-auto pb-6 px-4' >
      <div className='flex justify-center my-6'>
        <Link
          to="/soumettre-votive"
          className="bg-green-600 hover:bg-white border-2 border-green-600 text-white hover:text-green-600 font-bold py-3 px-6 rounded-lg text-lg transition-all duration-300 shadow-lg hover:shadow-xl"
        >
          + Ajouter une votive
        </Link>
      </div>
      <div className='sm:w-[80%] sm:m-auto'>
        <div className='mb-4'>
          <div className='flex justify-between items-center mb-2'>
            <p className='font-bold'>Filtres :</p>
            {(selectedTypes.length > 0 || selectedMonth) && (
              <button
                onClick={resetFilters}
                className='text-sm text-red-600 hover:text-red-800 underline'
              >
                Réinitialiser
              </button>
            )}
          </div>

          {/* Types d'événements */}
          <div className='mb-3'>
            <p className='text-sm text-gray-600 mb-1'>Types (plusieurs choix possibles) :</p>
            <div className='font-bold text-base flex-wrap text-gray-700 sm:text-center'>
              <button
                onClick={() => toggleType('votive')}
                className={`uppercase px-3 py-1 duration-200 border rounded m-1 ${
                  selectedTypes.includes('votive')
                    ? 'bg-green-500 text-white'
                    : 'hover:text-green-400 focus:underline focus:text-green-400'
                }`}
              >
                Votive
              </button>
              <button
                onClick={() => toggleType('petanque')}
                className={`uppercase px-3 py-1 duration-200 border rounded m-1 ${
                  selectedTypes.includes('petanque')
                    ? 'bg-green-500 text-white'
                    : 'hover:text-green-400 focus:underline focus:text-green-400'
                }`}
              >
                Pétanque
              </button>
              <button
                onClick={() => toggleType('foraine')}
                className={`uppercase px-3 py-1 duration-200 border rounded m-1 ${
                  selectedTypes.includes('foraine')
                    ? 'bg-green-500 text-white'
                    : 'hover:text-green-400 focus:underline focus:text-green-400'
                }`}
              >
                Fête Foraine
              </button>
            </div>
          </div>

          {/* Mois */}
          <div>
            <p className='text-sm text-gray-600 mb-1'>Période (un seul choix) :</p>
            <div className='font-bold text-base flex-wrap text-gray-700 sm:text-center'>
              <button
                onClick={() => selectMonth('juin')}
                className={`uppercase px-3 py-1 duration-200 border rounded m-1 ${
                  selectedMonth === 'juin'
                    ? 'bg-blue-500 text-white'
                    : 'hover:text-blue-400 focus:underline focus:text-blue-400'
                }`}
              >
                Juin
              </button>
              <button
                onClick={() => selectMonth('juillet')}
                className={`uppercase px-3 py-1 duration-200 border rounded m-1 ${
                  selectedMonth === 'juillet'
                    ? 'bg-blue-500 text-white'
                    : 'hover:text-blue-400 focus:underline focus:text-blue-400'
                }`}
              >
                Juillet
              </button>
              <button
                onClick={() => selectMonth('aout')}
                className={`uppercase px-3 py-1 duration-200 border rounded m-1 ${
                  selectedMonth === 'aout'
                    ? 'bg-blue-500 text-white'
                    : 'hover:text-blue-400 focus:underline focus:text-blue-400'
                }`}
              >
                Août
              </button>
              <button
                onClick={() => selectMonth('septembre')}
                className={`uppercase px-3 py-1 duration-200 border rounded m-1 ${
                  selectedMonth === 'septembre'
                    ? 'bg-blue-500 text-white'
                    : 'hover:text-blue-400 focus:underline focus:text-blue-400'
                }`}
              >
                Septembre
              </button>
              <button
                onClick={() => selectMonth('hivernal')}
                className={`uppercase px-3 py-1 duration-200 border rounded m-1 ${
                  selectedMonth === 'hivernal'
                    ? 'bg-blue-500 text-white'
                    : 'hover:text-blue-400 focus:underline focus:text-blue-400'
                }`}
              >
                Hivernal
              </button>
            </div>
          </div>
        </div>
      </div>


      <div className={`grid ${filteredVotives.length === 0 ? 'grid-cols-1 justify-items-center' : 'grid-cols-1 md:grid-cols-2'}`}>
        {filteredVotives.length === 0 ? (
          <div className='text-center bg-black bg-opacity-30 p-4 rounded-md mt-4 max-w-[400px]'>
            {/* Contenu à afficher si votives est vide */}
            <p className='font-bold'>Aucune votive prévu pour le filtre choisi.</p>
            <p className='text-xs text-red-600 mt-2'>essaye de changer de filtre</p>
          </div>
        ) : (
          <React.Fragment>
            {filteredVotives.map((item) => (
              <div key={item.id} className='py-3 m-2 px-2 shadow-2xl rounded-xl flex flex-col items-center hover:cursor-pointer'>
                <div className='flex w-full flex-col items-center md:items-start lg:flex-row' onClick={() => handleClick(item.image_url)}>
                  <img className='w-[15em] object-contain border-black border-4 lg:hover:w-[17em] duration-300' src={item.image_url || "/images/affiches/soon.webp"} alt={item.alt_text || item.title} />
                  <div className='lg:pl-4 sm:w-[80%] md:w-[100%] flex flex-col justify-between h-full'>
                    <div>
                      <h1 className='font-bold text-lg mt-4 underline-offset'>{item.title}</h1>
                      <p className='font-bold text-gray-600 my-2'>{item.date_show}</p>
                      <p className='text-green-600 font-bold mb-2'>{item.price}</p>
                      <p className='text-gray-600 text-sm font-sans mb-2'>{item.description}</p>
                    </div>
                    {item.compte_insta && (
                      <a href={item.compte_insta} target="_blank" rel="noreferrer" className='w-[100%] px-2 items-center justify-around py-2 border rounded hidden lg:flex blank'>
                        <p className='font-bold'>Instagram de l'organisation :</p>
                        <img src='/images/partenaires/insta.webp' alt='Compte instagram du comité des fêtes/jeunes' className='w-10' />
                      </a>
                    )}
                  </div>
                </div>
                {item.compte_insta && (
                  <a href={item.compte_insta} target="_blank" rel="noreferrer" className='w-[326px] flex items-center justify-around py-2 border rounded lg:hidden'>
                    <p className='font-bold'>Instagram de l'organisation :</p>
                    <img src='/images/partenaires/insta.webp' alt='' className='w-10' />
                  </a>
                )}
              </div>
            ))}
            {selectedImage && (
              <div className='fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-black bg-opacity-50 duration-500 z-20'>
                <div className='max-w-xl mx-auto'>
                  <img className='max-w-full' src={selectedImage} alt='Affiche de la fête votive' onClick={handleClose} />
                  <button className='absolute top-2 right-2 text-white font-bold bg-red-500 px-4 py-2 rounded' onClick={handleClose}>
                    X
                  </button>
                </div>
              </div>
            )}
          </React.Fragment>
        )}
      </div>
    </div>
  )
}

export default Card